import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import './styles/main.scss';
import App from './App.tsx';

// Initialize Sentry early
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.1,
  });
  console.log('Sentry initialized for error monitoring');
}

// Only register Firebase messaging service worker if Firebase is configured
const isFirebaseConfigured =
  import.meta.env.VITE_FIREBASE_API_KEY &&
  import.meta.env.VITE_FIREBASE_API_KEY !== 'placeholder' &&
  import.meta.env.VITE_FIREBASE_API_KEY.length > 10;

if ('serviceWorker' in navigator && isFirebaseConfigured) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .catch(err => {
      console.error('Service Worker registration failed:', err);
    });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
